import { render, staticRenderFns } from "./FacilityContacts.vue?vue&type=template&id=78c4b96d&scoped=true"
import script from "./FacilityContacts.vue?vue&type=script&lang=js"
export * from "./FacilityContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c4b96d",
  null
  
)

export default component.exports